import { Stack, Typography, Box } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ragService from "../../services/ragService";
import { cardStyle } from "../../shared/Theme";
import CyberRiskRecommendedModal from "./CyberRiskRecommendedModal";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const CardCriticalRisk = (props) => {

	const navigate = useNavigate();
	
	let [ showRecommendation, setShowRecommendation ] = useState(null);
	
	const handleTitleClick = () => {
		navigate("/risk");
	};
	
	const handleRecommendationClick = (recommendation) => {
		setShowRecommendation(recommendation);
	};
	
	const handleRecommendationModalClose = () => {
		setShowRecommendation(null);
	};
	
	return (
		<React.Fragment>
			<Stack direction="column" sx={{ ...cardStyle, width: "28em", height: "16em" }}>
				<Typography
					variant="h5"
					sx={{
						width: "100%",
						textAlign: "center",
						marginTop: "1em",
						marginBottom: "0.75em",
						cursor: "pointer",
						fontWeight: "bold"
					}}
					onClick={handleTitleClick}
				>
					Top 3 Critical Risks
				</Typography>
				<Box sx={{ marginBottom: "1em" }}>
					{ragService.recommendations.map((recommendation, i) => {
						if (i >= 3) return ( <React.Fragment key={`top_recommendation_${i}`}/> );
						return (
							<Stack
								key={`top_recommendation_${i}`}
								direction="row"
								alignItems="center"
								justifyContent="center"
								sx={{ cursor: "pointer", margin: "0 1em 0em 1em" }}
								onClick={() => {handleRecommendationClick(recommendation)}}
							>
								<Typography sx={{ fontSize: "1.8em", width: "1em", fontWeight: "bold" }}>
									{`${i + 1}`}
								</Typography>
								<Typography sx={{ fontSize: "0.9em", width: "20em", marginRight: "0.5em"}}>
									{`${recommendation.title}`}
								</Typography>
								<ArrowBackIosNewIcon sx={{ transform: "rotate(270deg)", color: "text.primary.contrastText" }}/>
							</Stack>
						);
					})}
				</Box>
			</Stack>
			<CyberRiskRecommendedModal
				recommendation={showRecommendation}
				onClose={handleRecommendationModalClose}
			/>
		</React.Fragment>
	);

}

export default CardCriticalRisk;